import React, { Component, Fragment } from 'react'
import { CollectionEditForm } from 'components'

import IconButton from '@material-ui/core/IconButton'
import DownloadIcon from '@material-ui/icons/CloudDownload'
import { authorizedLink } from 'utils'


export class DownloadsForm extends Component{

  constructor(properties) {
    super(properties)

    this.attributes = [
      {name: 'name',        label: 'Name',        required: true},
      {name: 'description', label: 'Description', required: true},
      {name: 'attachment',  label: 'Attachment',  required: false,
              renderer: this.attachmentRenderer, input: this.attachmentInput}
    ]
  }

  attachmentInput = (element, form) => {
    return (
      <form.FileUploadField key='attachment' label='Attachment' attribute='attachment' alt='PDF' acceptedTypes=".pdf"/>
    )
  }

  attachmentRenderer = ({uuid, name, description, attachmentFileName, attachmentUrl}) => {
    return (
      <Fragment>
        {/** no refferer**/}
        { !uuid &&
          <a target="_blank" rel="noopener noreferrer" href={authorizedLink(attachmentUrl)}>
            <IconButton>
              <DownloadIcon/>
            </IconButton>
          </a>
        }
        {attachmentFileName}
      </Fragment>
    )
  }

  render = () =>
    <CollectionEditForm elements={ this.props.downloads } attributes={ this.attributes } onElementsChange={ this.props.onDownloadsChange }/>
}

export default DownloadsForm